import { color } from '@design/templateFns';
import { Star } from '@icon/index';
import { ReactNode } from 'react';
import styled from 'styled-components';

export interface FavoriteButtonProps {
  $isFavorite?: boolean | null;
  className?: string;
  dataTestId?: string;
  onClick: () => void;
}

export const FavoriteButton = ({
  $isFavorite = false,
  className,
  dataTestId,
  onClick,
}: FavoriteButtonProps): ReactNode => {
  return (
    <FavoriteButtonWrapper
      onClick={onClick}
      $isFavorite={$isFavorite}
      className={className}
      data-testid={dataTestId}
    >
      <Star />
    </FavoriteButtonWrapper>
  );
};

const FavoriteButtonWrapper = styled.button<{ $isFavorite?: boolean | null }>`
  //remove dd default button styles
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  overflow: visible;

  // color declaration controls stroke (set to currentColor)
  // fill declaration controls inner fill (or just fill)

  svg path {
    color: ${color('gray4')};
    fill: ${({ $isFavorite }) => ($isFavorite ? color('gray4') : color('bg'))};
    transition: color 0.3s ease-in-out, fill 0.3s ease-in-out;
  }

  &:hover {
    svg path {
      color: ${color('gray3')};
      fill: ${color('gray3')};
    }
  }
`;
